var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNavCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 29C33 31.209 31.209 33 29 33H5C2.791 33 1 31.209 1 29V5C1 2.791 2.791 1 5 1H29C31.209 1 33 2.791 33 5V29Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.177 15.777L5.40301 12.256C5.30001 12.203 5.17701 12.207 5.07801 12.268C4.97901 12.329 4.91901 12.434 4.91901 12.551V14.701C4.91901 14.824 4.98801 14.937 5.09801 14.994L8.96201 17.004L5.09801 19.012C4.98901 19.069 4.91901 19.182 4.91901 19.307V21.45C4.91901 21.565 4.98001 21.673 5.07801 21.733C5.13101 21.764 5.19101 21.782 5.25001 21.782C5.30301 21.782 5.35501 21.768 5.40301 21.743L12.177 18.223C12.288 18.164 12.357 18.051 12.357 17.928V16.073C12.356 15.947 12.288 15.834 12.177 15.777Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.541 15.777L13.767 12.256C13.663 12.203 13.54 12.207 13.441 12.268C13.342 12.329 13.283 12.434 13.283 12.551V14.701C13.283 14.824 13.351 14.937 13.461 14.994L17.326 17.004L13.461 19.012C13.352 19.069 13.283 19.182 13.283 19.307V21.45C13.283 21.565 13.343 21.673 13.441 21.733C13.494 21.764 13.554 21.782 13.614 21.782C13.666 21.782 13.718 21.768 13.767 21.743L20.541 18.223C20.651 18.164 20.72 18.051 20.72 17.928V16.073C20.72 15.947 20.651 15.834 20.541 15.777Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.903 15.777L22.128 12.256C22.025 12.203 21.901 12.207 21.804 12.268C21.704 12.329 21.644 12.434 21.644 12.551V14.701C21.644 14.824 21.712 14.937 21.824 14.994L25.687 17.004L21.824 19.012C21.713 19.069 21.644 19.182 21.644 19.307V21.45C21.644 21.565 21.705 21.673 21.804 21.733C21.857 21.764 21.915 21.782 21.976 21.782C22.028 21.782 22.08 21.768 22.128 21.743L28.903 18.223C29.012 18.164 29.081 18.051 29.081 17.928V16.073C29.081 15.947 29.013 15.834 28.903 15.777Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNavCollapsed);
export default __webpack_public_path__ + "static/media/logo-nav-collapsed.5ed57713e39e66006b3af72e3fa6cc3e.svg";
export { ForwardRef as ReactComponent };